import React from 'react';
import { CommentsStorage } from '../../context/CommentsContext';
import Box from './box';

function Comments() {
  return (
    <CommentsStorage>
      <Box />
    </CommentsStorage>
  );
}

export default Comments;
